export { ShortcutsPage } from './ShortcutsPage';
